import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api, API } from "@/lib/api";
import { Download, ClipboardList, FileText } from "lucide-react";

const ABS = (u) => (u && u.startsWith("/api/") ? `${API.replace(/\/api$/, "")}${u}` : u);

export default function StudentApplications() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/student/internships/my-applications").then((r) => setItems(r.data || [])); }, []);
  return (
    <DashboardLayout>
      <h1 className="heading text-2xl font-bold">My Applications</h1>
      <p className="text-sm text-slate-500 mt-1">Track status, download attendance sheets and certificates.</p>
      {items.length === 0 ? (
        <div className="mt-8 p-14 rounded-2xl border border-dashed border-slate-300 text-center">
          <ClipboardList size={40} className="mx-auto text-slate-300" />
          <div className="mt-3 text-slate-500">You haven't applied to any internship yet.</div>
        </div>
      ) : (
        <div className="mt-6 rounded-xl border border-slate-200 bg-white overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left">
              <tr>
                <th className="p-3 font-semibold">Program</th>
                <th className="p-3 font-semibold">Applied</th>
                <th className="p-3 font-semibold">Status</th>
                <th className="p-3 font-semibold">Attendance</th>
                <th className="p-3 font-semibold">Certificate</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} className="border-t border-slate-100">
                  <td className="p-3 font-semibold">{a.internship_title}</td>
                  <td className="p-3 text-slate-500">{new Date(a.applied_at).toLocaleDateString()}</td>
                  <td className="p-3">
                    <span className={`text-[10px] px-2 py-1 rounded font-bold uppercase tracking-wider ${
                      a.status === "approved" ? "bg-emerald-100 text-emerald-700" :
                      a.status === "rejected" ? "bg-red-100 text-red-700" :
                      a.status === "completed" ? "bg-indigo-100 text-indigo-700" :
                      "bg-amber-100 text-amber-700"
                    }`}>{a.status}</span>
                  </td>
                  <td className="p-3">
                    {a.attendance_url ? (
                      <a
                        href={ABS(a.attendance_url)}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-1 text-indigo-600 font-semibold"
                        data-testid={`attend-download-${a.id}`}
                      >
                        <FileText size={14} /> Download
                      </a>
                    ) : (
                      <span className="text-xs text-slate-400">—</span>
                    )}
                  </td>
                  <td className="p-3">
                    {a.certificate_url ? (
                      <a
                        href={ABS(a.certificate_url)}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-1 text-brand font-semibold"
                        data-testid={`cert-download-${a.id}`}
                      >
                        <Download size={14} /> {a.certificate_no || "Download"}
                      </a>
                    ) : (
                      <span className="text-xs text-slate-400">Pending</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </DashboardLayout>
  );
}
